<template>
  <HeaderContent title="Guest"/>
  <ActionContent ctaText="Add Guest" @action="modal = !modal" :filterDate="false"/>
  <GuestStatistics title="Guest Statistics" :data="statistics" />
  <GuestForm :modal="modal" @update:modal="modal = $event"/>
  <GuestFilter :modalFilter="modalFilter" @update:modalFilter="modalFilter = $event"/>
  <GuestConfirm title="Confirmation" :modalConfirm="modalConfirm" @update:modalConfirm="modalConfirm = $event">
    <template #text>Are you sure to delete this data ?</template>
  </GuestConfirm>
  <GuestDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions" :detail="true"/>
</template>

<script>

import { ref } from 'vue';
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import GuestForm from "./GuestForm.vue";
import GuestFilter from "./GuestFilter.vue";
import GuestConfirm from "@/components/ModalDialog.vue";
import GuestStatistics from "@/components/StatisticData.vue";
import GuestDataTable from "@/components/DataTable.vue";
import iconForeign from '../../../public/icons/user-cowboy.svg';
import iconLocal from '../../../public/icons/people-roof.svg';
import iconStay from '../../../public/icons/street-view.svg';
import iconOveral from '../../../public/icons/square-poll-vertical.svg';

export default {
  components: {
    HeaderContent,
    ActionContent,
    GuestForm,
    GuestFilter,
    GuestConfirm,
    GuestStatistics,
    GuestDataTable
  },
  setup(){
    const modal = ref(false)
    const modalFilter = ref(false)
    const modalConfirm = ref(false)
    const currentPage = ref(1)
    const data = ref([
      { 
        no: 1, 
        id: '11111', 
        status_guest: 'Mr',
        name: 'Bones', 
        nationality: 'Africa',
        contact: '-',
        address: '-', 
        city: '-', 
      },
      { 
        no: 1, 
        id: '11111', 
        status_guest: 'Mr',
        name: 'Jacob', 
        nationality: 'England',
        contact: '-',
        address: '-', 
        city: '-', 
      },
      { 
        no: 1, 
        id: '11111', 
        status_guest: 'Mr',
        name: 'John Doe', 
        nationality: 'America',
        contact: '-',
        address: '-', 
        city: '-', 
      },
      { 
        no: 1, 
        id: '11111', 
        status_guest: 'Ms',
        name: 'Clara', 
        nationality: 'Swiss',
        contact: '-',
        address: '-', 
        city: '-', 
      },
      { 
        no: 1, 
        id: '11111', 
        status_guest: 'Ms',
        name: 'Elmira', 
        nationality: 'Belgium',
        contact: '-',
        address: '-', 
        city: '-', 
      },
    ]);
    const headers = ref([
      {
        key: 'id',
        label: 'ID/Passport',
        sortable: true,
      },
      {
        key: 'status_guest',
        label: 'Status',
        sortable: true,
      },
      {
        key: 'name',
        label: 'Name',
        sortable: true,
      },
      {
        key: 'nationality',
        label: 'Nationality',
        sortable: true,
      },
      {
        key: 'contact',
        label: 'Contact No',
        sortable: true,
      },
      {
        key: 'address',
        label: 'Address',
        sortable: true,
      },
      {
        key: 'city',
        label: 'City',
        sortable: true,
      },
      {
        key: 'action',
        label: 'Actions',
      }
    ])
    const customActions = ref([
      {
          label: 'Edit',
          variant: 'success',
          icon: 'fas fa-edit',
          action: (item) => {
          console.log('Edit action clicked for:', item);
          // Implement your edit logic here
          }
      },
      {
          label: 'Delete',
          variant: 'danger',
          icon: 'fas fa-trash',
          action: (item) => {
          console.log('Delete action clicked for:', item);
          // Implement your delete logic here
          }
      },
      
    ]);
    const statistics = ref([
      {
        label: 'Total',
        key: 'Foreign Guest',
        value: 13,
        color: 'info',
        icon: iconForeign,
      },
      {
        label: 'Total',
        key: 'Local Guest',
        value: 11,
        color: 'primary',
        icon: iconLocal,
      },
      {
        label: 'Total',
        key: 'Staying Guest',
        value: 15,
        color: 'primary',
        icon: iconStay,
      },
      {
        label: 'Total',
        key: 'Overall Guest',
        value: 23,
        color: 'primary',
        icon: iconOveral,
      },
    ])


    return{
      data,
      headers,
      modal,
      modalFilter,
      modalConfirm,
      currentPage,
      customActions,
      statistics,
    }
  }


}
</script>

<style>

</style>